import { i18n } from 'next-i18next'
import en from '../reasons/en.json'
import es from '../reasons/es.json'
import fr from '../reasons/fr.json'
import ko from '../reasons/ko.json'
import de from '../reasons/de.json'
import pt from '../reasons/pt.json'
import it from '../reasons/it.json'
import pl from '../reasons/pl.json'
import zh from '../reasons/zh.json'
import { OffsetReason } from 'src/core/models'
import { OTHER_REASON_ID } from 'src/core/helpers'


const reasons = { en, es, fr, ko, de, pt, it, pl, zh }

const getReasonName = (id: number, text: string): string => {
  const reasonList = reasons[i18n.language || 'en']['offset_reasons']
  return reasonList[id] || text
}

export const getOffsetReasonsTranslated = (reasons: OffsetReason[]): OffsetReason[] => {
  let translatedReasons = reasons.map(r => {
    return { ...r, text: getReasonName(r.id, r.text) }
  })
  if (!translatedReasons.some(r => r.id === OTHER_REASON_ID)) {
    const otherReason: OffsetReason = { id: OTHER_REASON_ID, text: getReasonName(OTHER_REASON_ID, 'Other') }
    translatedReasons = [...translatedReasons, otherReason]
  }
  return translatedReasons
}
